import { useTranslation } from 'react-i18next';

import { getEvaluationCollegialFileDownloadUrl } from '@/module/Evaluation/model/EvaluationApi';
import { useEvaluationUploadCollegialFile } from '@/module/Evaluation/model/EvaluationQuery';

import { Id, PersistentFile, useAppNotification } from '@feature/utils';

import { EvaluationAuthorFile } from './EvaluationAuthorFile';

interface EvaluationAuthorCollegialFileProps {
  userId: Id;
  evaluationId: Id;
  file: PersistentFile | null;
}

export function EvaluationAuthorCollegialFile({ evaluationId, userId, file }: EvaluationAuthorCollegialFileProps) {
  const { mutate, isPending } = useEvaluationUploadCollegialFile(evaluationId, userId);
  const notification = useAppNotification();
  const { t } = useTranslation();

  const onUpload = (newFile: File) => {
    mutate(newFile, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <EvaluationAuthorFile
      onUpload={onUpload}
      file={file}
      onDownload={() => window.open(getEvaluationCollegialFileDownloadUrl(evaluationId, userId))}
      isSubmitting={isPending}
      label={t('evaluation.files.collegial.label')}
      description={t('evaluation.files.collegial.description')}
    />
  );
}
